const initialState = {
  presignedUrl: null,
  thumbnailFile: null,
  newThumbnailUrl: null,
  loadedMediaUrl: null,
  isUploading: false,
  hasEditorChanged: false,
  finishedLoading: false
};

const actions = {
  OPEN_IMAGE_EDITOR: 'OPEN_IMAGE_EDITOR',
  CLOSE_IMAGE_EDITOR: 'CLOSE_IMAGE_EDITOR',
  START_PRESIGNED_URL: 'START_PRESIGNED_URL',
  PRESIGNED_URL_SUCCESS: 'PRESIGNED_URL_SUCCESS',
  START_THUMBNAIL_UPLOAD: 'START_THUMBNAIL_UPLOAD',
  THUMBNAIL_UPLOAD_SUCCESS: 'THUMBNAIL_UPLOAD_SUCCESS',
  FILE_SELECTED: 'FILE_SELECTED',
  LOAD_EXISTING_IMAGE: 'LOAD_EXISTING_IMAGE',
  CLEAR_IMAGE_EDITOR: 'CLEAR_IMAGE_EDITOR',
  IMAGE_EDITOR_CHANGED: 'IMAGE_EDITOR_CHANGED',
  FINISHED_LOADING: 'FINISHED_LOADING'
};

function reducer(state, action) {
  const {
    CLOSE_IMAGE_EDITOR,
    START_PRESIGNED_URL,
    PRESIGNED_URL_SUCCESS,
    START_THUMBNAIL_UPLOAD,
    THUMBNAIL_UPLOAD_SUCCESS,
    FILE_SELECTED,
    LOAD_EXISTING_IMAGE,
    CLEAR_IMAGE_EDITOR,
    IMAGE_EDITOR_CHANGED,
    FINISHED_LOADING
  } = actions;

  switch (action.type) {
    case CLOSE_IMAGE_EDITOR:
      return {
        ...state,
        isUploading: false,
        thumbnailFile: null,
        presignedUrl: null,
        loadedMediaUrl: null,
        newThumbnailUrl: null,
        hasEditorChanged: false,
        finishedLoading: false
      };
    case START_PRESIGNED_URL:
      return { ...state, isUploading: true };
    case PRESIGNED_URL_SUCCESS:
      return { ...state, presignedUrl: action.presignedUrl, isUploading: false };
    case START_THUMBNAIL_UPLOAD:
      return {
        ...state,
        newThumbnailUrl: action.newThumbnailUrl,
        presignedUrl: null,
        isUploading: true
      };
    case THUMBNAIL_UPLOAD_SUCCESS:
      return {
        ...state,
        isUploading: false
      };
    case FILE_SELECTED:
      return { ...state, thumbnailFile: action.thumbnailFile, hasEditorChanged: true };
    case LOAD_EXISTING_IMAGE:
      return { ...state, loadedMediaUrl: action.loadedMediaUrl };
    case CLEAR_IMAGE_EDITOR:
      return {
        ...state,
        isUploading: false,
        newThumbnailUrl: null,
        thumbnailFile: null,
        presignedUrl: null,
        loadedMediaUrl: null,
        hasEditorChanged: false,
        finishedLoading: false
      };
    case IMAGE_EDITOR_CHANGED:
      return {
        ...state,
        hasEditorChanged: action.editedState
      };
    case FINISHED_LOADING:
      return {
        ...state,
        finishedLoading: true
      };
    default:
      throw new Error();
  }
}

export { initialState, reducer, actions };



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpUpdateThumbnailModal.state.jsx